export const isNull = value => value === null

export const isUndefined = value => value === undefined

export const isEmpty = value => {
  if (value === '' || isUndefined(value) || isNull(value)) return true
  if (Array.isArray(value)) return value.length === 0
  if (typeof value === 'object') return Object.keys(value).length === 0
  return false
}

export const isType = (value, type) => typeof value === type

export const required = value => !isNull(value) && !isUndefined(value) && !isEmpty(value)

export const firstLetterToUppercase = string => string.charAt(0)
  .toUpperCase() + string.slice(1)
